module.exports = {
	language: {
		name: 'English'
	},
	user: {
		login: '首页',
		aboustus: '关于庆川',
		aboustus1:'关于庆川数控',
		Products: '产品中心',
		Uselocation:'应用领域',
		News: '新闻资讯',
		socianl: '社会责任',
		Feedback: '在线留言',
		Contactus: '联系我们',
		Language: '语言版本',
		Chinese: '中文',
		English: '英文',
		projectList: '产品列表',
		projectDetail: '产品详情',
		Productkeywords: '产品关键词',
		search: '搜索',
		focusUpdate: '聚焦公司实时动态',
		searchCon: '请输入搜索内容',
		socianlResponsibility: '福建省庆川数控机械有限公司始终秉持 “智造赋能，责任担当” 理念，积极践行社会责任。在产业发展中，专注数控机械研发制造，以高品质产品助力制造业升级，为客户创造价值，为行业培养专业人才；在社会层面，关注环保，推行绿色生产，降低能耗与污染，积极参与公益，以实际行动回馈社会，用科技与担当书写企业社会责任篇章，推动经济与社会的可持续共生发展 。',
		homesynopsis: '福建省庆川数控机械有限公司（原莆田市荔城区黄石庆川机械厂）始于2000年，是一家专注于 “高端智能装备研发、生产、销售、服务为一体的精密数控机床制造” 的国家高新技术企业、国家知识产权优势企业。',
		enterFurui: '走进福瑞',
		Chongqing: '福建省庆川数控机械有限公司',
		text1: '研发、生产、销售、服务为一体',
		home1: '始创于2000年',
		home2: '产品销往 300 + 城市',
		home3: '发明专利 7 项',
		home4:'实用新型及外观专利 35 项',
		home5: '年销售 3000+台',
		home6: '年销售 260 万台',
		home7: '售后服务 1500 + 台',
		workcenter: '加工中心',
		work1:'立式',
		work2:'卧式',
		work3:'龙门',
		work4:'多头立式',
		work5:'立卧两用',
		work6:'卧铣',
		work7: '高速钻工',
		product1:'QC850L 三线卧轨',
		product2:'OC850L2 两线一硬',
		product3: 'OC855L2 两线一硬',
		aboutust1:'企业简介',
		aboutust2:'发展历程',
		aboutush2:'经营理念',
		aboutush3:'创新驱动',
		aboutusp1:'福建省庆川数控机械有限公司创建于2015年，是一家专注于 “高端智能装备研发、生产、销售、服务为一体的精密数控机床制造” 的国家高新技术企业、国家知识产权优势企业。',
		aboutusp2:'公司拥有两条先进的数控装备生产线，现设备有：台湾进口的精密五面体龙门铣床、数控龙门磨床、平面磨床、多功能龙门铣床、立式 CNC 、卧式 CNC 、索尼尼绍激光镭射-侧测、驱动检测系统、三坐标、准直仪、进口水平仪、动平衡仪等高端精密设备70多套，能够根据客户需求定制各种标准或非标准设备。',
		aboutusp3:'公司以市场需求为导向，以 “诚信、创新、高效、协作、共赢” 为经营理念，创意创新和技术创新为依托的可持续发展战略，不断提升各产品的科技含量，谋求共同发展，为新、老客户提供高精度、高稳定性的优质产品。以优质产品和完善的服务，为客户创造最大价值，提升客户的产品竞争力，赢得了广大客户的信赖与支持。',
		aboutusp4:'坚持以诚取信、以信立誉的原则，把诚信经营作为企业的立业之道、兴业之本，把公司打造成世界“一流智能数控装备制造企业”。',
		aboutusp5:' 公司不断创新精进，吸纳国内外先进科技成果，发展成为拥有自主研发和自我检测的综合性数控机床专业制造商，主要产品有立式工中心、龙门加工中心、卧式加工中心、钻攻加工中心等系列光机与整机的数控机床，广泛应用在航空业、新能源及汽车制造业、3C领域、半导体行业、医疗器械业、精密模具与机械零件加工及制造业。',
		honorListp1:'国家高新技术企业、国家知识产权优势企业、福建省“专精特新”企业、省龙头工业企业、省知识产权优势企业、省科技小巨人企业、IS0质量管理认证体系',
		honorListp2:'莆田市龙头工业企业、市突出经济贡献企业、市企业技术中心、市工业企业设计中心、市重合同守信用企业;',
		honorListp3:'拥有“发明专利7项、实用新型及外观设计专利35项”;',
		honorListp4:'莆田学院研究生联合基地、福建工程学院等多所高校共建产、学、研校企合作及实习基地;',
		honorListp5:'省机床工具行业协会理事单位、省企业经济评估协会会员单位、市企业与企业家联合协会副会长单位。',
		chongqingfu: '与众不同，互利双赢！',
		chongqingcontent1: '多元化商品+全链路服务',
		chongqingcontent2: '在全球化的浪潮下，市场发展的需求，加大产业转型升级，发挥资源共享、合作共赢的模式，公司以机床产业机械业务为核心，涵盖产品研发、机加工和组装光机、销售及服务为一体的全产业链。',
		chongqingcontent3: '厦门恒盈盛通商贸创立于',
		chongqingcontent4: '产品业务布局',
		chongqingcontent5: '现代化设备',
		chongqingcontent6: '先进的生产设备和自动化生产线',
		chongqingcontent7: '荣誉资质',
		chongqingcontent8: '福建省“专精特新”中小企业，拥有 100 多项国内外专利',
		chongqingcontent9: '福瑞科技电子有限责任公司@版权声明',
		chongqingcontent10: '闽ICP备1234567号',
		chongqingcontent11: '@CopyRight 2009-2014 版本所有',
		chongqingcontent12: '渝公网安备 50011302001512 号',
		chongqingcontent13: '联系',
		chongqingcontent14: '公司具有雄厚技术力量队伍：拥有一流的数控机床制造技术、一批高素质优秀的专业技术人才和强大研发设计队伍，具有丰富的管理经验和顶尖的技术骨干，带领全体员工精益求精为您服务，产、销独立一体化的管理模式，从而提高了产品竞争力及性价比；在设计和参数上均采用台湾、日本、德国等同类高端产品的技术标准，在质量和工作性能上可以给每一位客户一个可靠的质量保证与技术服务。',
		chongqingcontent15: '电话',
		chongqingcontent16: '邮箱',
		chongqingcontent17: '关于',
		chongqingcontent18: '产品',
		chongqingcontent19: '新闻',
		chongqingcontent20: '在线留言',
		chongqingcontent21: '联系方式',
		chongqingcontent22: '福建省庆川数控机械有限公司与国内外多家知名机械制造及加工企业建立深度供销战略合作关系，提供涵盖立式加工中心、卧式加工中心、龙门加工中心等多元化数控设备，以先进的技术、可靠的品质与极具竞争力的价格，赢得客户认可与国内外市场信赖。公司将始终秉持 “客户至上、品质卓越、创新驱动、诚信共赢” 的经营理念，竭诚为客户打造定制化解决方案，提供全周期优质服务，助力伙伴实现高效生产与价值提升。',
		chongqingcontent23: '请输入你的手机',
		chongqingcontent24: '请输入你的邮箱',
		chongqingcontent25: '提交',
		chongqingcontent26: '企业介绍',
		chongqingcontent27: '资质荣誉',
		chongqingcontent28: '企业文化',
		chongqingcontent29: '联系方式',
		chongqingcontent30: '福建省莆田市黄石镇梅雪南大道118号',
		chongqingcontent31: '地图位置',
		chongqingcontent32: '微信公众号',
		chongqingcontent33: '主要产品',
		chongqingcontent34: '企业荣誉',
		news1: '获批高新技术企业',
		news2: '福建省庆川数控机械有限公司被正式认定为高新技术企业，标志着该公司在技术创新和研发能力方面得到国家高度认可，为其未来可持续发展奠定了坚实基础。',
		news3: '校企合作交流',
		news4: '莆田学院机电与信息工程学院电气系主任郭晓君与通信工程系主任陈德礼分别带队走访福建省庆川数控机械有限公司。双方就产学研项目合作、实习专业与人数需求等方面展开具体沟通，此前双方已签订实习实践基地合作协议，此次走访进一步达成持续科研合作意向。',
		news5: '产能预计翻番',
		news6: '报道显示，项目现场塔吊转动，工人有序施工。公司原有厂房和旧设备限制了产能和工艺提升，为此公司淘汰落后设备，引进高精度机床与检验设备。项目建成后，预计年产量提升至 2700 台，实现产能翻番。',
		uselocationt1:'全部',
		uselocationt2:'汽车行业',
		uselocationt3:'电子行业',
		uselocationt4:'航空行业',
		uselocationt5: '模具行业',
		productst1:'立式加工中心',
		productst2:'卧式加工中心',
		productst3:'龙门加工中心',
		productst4:'立卧两用加工中心',
		productst5:'卧铣加工中心',
		productst6: '高速钻攻机',
		newst1:'公司新闻',
		newst2:'行业资讯',
		newst3: '院校合作',
		companySimple: '公司有员工170多人，共占地面积为120亩，厂房约8.6万多㎡，我们始终秉承“以客户为中心 、以高品质为本”不断进取、不断完善，竭诚为您量身定造需要的机床设备。',
		companyhonist: '国家高新技术企业、国家知识产权优势企业、福建省“专精特新”企业、省龙头工业企业、省知识产权优势企业、省科技小巨人企业、ISO质量管理认证体系；莆田市龙头工业企业、市突出经济贡献企业、市企业技术中心、市工业企业设计中心、市重合同守信用企业；市企业与企业家联合协会副会长单位、省机床工具行业协会理事单位、省企业经济评估协会会员单位；莆田学院研究生联合培养基地、福建工程学院等多所高校共建产、学、研校企合作，知识产权40多项（其中7项发明专利）。',
		management: '精细化管理模式',
		managementh1: '机床品质管控标准',
		managementh1_1: '线轨的平行度平面度要求在0.01mm以内',
		managementh1_2: '主轴联轴器同心度要求在 0.005mm 以内',
		managementh1_3: '主轴安装面平面度在0.005mm以内',
		managementh1_4: 'XZ轴垂直度0.01mm 以内',
		managementh1_5: 'XY垂直度在0.005mm 以内',
		managementh1_6: '丝杆平行度平面度在0.01mm以内',
		managementh1_7: '铸件硬度要求达到HB200±20',
		managementh2: '精益求精，铸就精品',
		managementh2_1: '主轴振动要求在3um以内',
		managementh2_2: '实物加工检测',
		managementh2_3: '球杆仪真圆度300mm在0.01mm以内',
		managementh2_4: '主轴噪音检测',
		managementh2_5: '主轴温升检测',
		managementh2_6: '激光镭射检测及校正补偿',
		managementh2_7: '主轴偏摆 300mm 在 0.008mm 以内',
		managementh2_8: '工作台平面度在 0.02mm 以内',
		managementh2_9: '主轴拉力刀力检测',
		managementh3: '精密主轴',
		managementh3_1: '主轴采用台湾知名品牌。主轴为日本镍铬钼钢(SNCM21)材质。',
		managementh3_2: '经标准热处理程序后加工研磨，以达高韧性、高耐磨耗、高精度、高稳定性要求。',
		managementh3_3: '采用世界知名厂牌 P4(NSK)轴承',
		managementh3_4: '采用 KLUBER NBU 15 油脂润滑。',
		managementh3_5: '出厂主轴 300mm 偏摆均于 0.008mm 以内。25mm偏摆值于0.003mm 以内。',
		managementh3_6: '采用德国进口油压式拉力计,精确检测主轴拉力。',
		managementh3_7: '使用 CEMB 计算机平衡校正机,精确校验主轴平衡。',
		managementh3_8: '校验主轴平衡已达到 ISO1940 规范 G1 等级。',
		managementh4: '三种主轴传动类型',
		managementh4_1: '直联转动',
		managementh4_2: 'BT-40 主轴同轴直联驱动，主轴同电机直接结合，从而消除了皮带连接的滞后,使主轴同电机之间灵敏度更高，以提供良好的加工光洁度和更高的热稳定性。同轴直驱主轴可选择转速有 12000rpm 和15000rpm,适用于高转速,快进给,轻切削:高光洁度的工件或产品。',
		managementh4_3: '皮带传动',
		managementh4_4: '皮带驱动由电机通过皮带实现驱动。该装置为一系列加工操作提供了扭矩与转速的良好结合，具有很高的性价比。',
		managementh4_5: '齿轮传动',
		managementh4_6: '齿轮驱动主轴能够提供重切削所需的低速高扭矩，同时还具备以 6000rpm的转速高速加工的能力。齿轮箱内配有一个干油池式润滑系统，为箱内的所有关键部位循环供油润滑。齿轮箱用聚氨酯衬垫分隔开,从而消除了振动,避免了表面精加工产生刀痕。齿轮驱动为 BT-50主轴机床的选购配置。',
		managementh5: 'P级精密型线性导轨',
		managementh5_1: '滚珠线性导',
		managementh5_2: '滚柱线导轨',
		managementh5_3: '线性导轨零间隙,圆弧切削,斜面切削，表面纹路较均匀。',
		managementh5_4: '适用高速运转，且大幅度降低机台所需驱动马力。',
		managementh5_5: '线性导轨,以滚动代替滑动,摩擦损失小,反应灵敏,定位精度高。',
		managementh5_6: '可同时承受上下左右方向的负荷,且负荷下导轨接触面仍以多点接触,切削刚性不会降低。',
		managementh5_7: '组装容易具有互换性，且润滑构造简单。',
		managementh5_8: '线性导轨的磨耗量非常微小,使用的寿命长。',
		managementh5_9: '滚珠线性导轨是点接触，耐磨损,使用寿命长。',
		managementh5_10: '滚柱线性导轨是面接触,在使用中相对噪音微大一点比滚珠线轨载重要好、刚性好。',
		managementh6: '滑动硬轨',
		managementh6_1: '硬轨的导轨和床身是一体的铸造件,在此基础上加工出导轨,导轨滑动面均经高频淬火处理，再经精研磨，导轨滑动面皆配合进口氟素树脂 TURCITE-B精密铲刮,并使每一处贴面均受完全润滑,硬轨导轨刚性好,承载能力强,进给速度相对较慢,适合重切及模具方面加工。',
		managementh7: 'C3级精密滚动丝杆',
		managementh7_1: '所有机型采用C3 级双螺帽预压之精密滚珠丝杆，配合两端支撑座的预拉设计，有效的消除传动背隙并预先补偿温升之误差,确保机器定位精度和重复定位精度。',
		managementh8: '刀库特性及参数',
		managementh8_1: '刀库特性',
		managementh8_2: '双滚子凸轮分割机构，分割精度高故障率低，结构简单,维修方便,使用寿命长。',
		managementh8_3: '全进口工程塑料刀套，质量轻，强度高,不易损坏。',
		managementh8_4: '分割式刀臂,同心度高,噪音小。',
		managementh8_5: '电子开关全系列采用进口原件品质保证。',
		managementh9: '机床高精度的可追溯性',
		managementh9_1: '机床出色的定位精度',
		managementh8_6:'刀库参数',
	}
}